// @flow

import React from 'react';
import _ from 'lodash';

import RoutingEnum from 'constants/RoutingEnum';

import Listener from 'PMT/flux/Listener';

import { Events } from 'constants';

import {
  RouteAction,
  RestaurantAction
} from 'actions';

import {
  RestaurantStore,
  ProAccountStore
} from 'stores';

import {
  ProRole,
  RolesList,
  RestaurantsGroup
} from 'PMT/entities/security';

// -- views
import {
  RoundButton,
  AbstractComponent
} from 'components';
import Ariane from 'PMT/components/Ariane';

import RestaurantsGroupHierarchyView from 'components/restaurantsGroup/RestaurantsGroupHierarchyView';

export default class RestaurantsGroupPage extends AbstractComponent {

  state = {
    restaurantsGroup: null
  };

  constructor() {
    super();

    this.arianeIcon = 'fa-users';
    this.arianeDetails = [
      {
        name: 'Utilisateurs',
        link: RoutingEnum.PRO_accountS_LIST_PAGE
      },
      {
        name: 'Restaurants',
        link: null
      }
    ];
  }

  componentDidMount() {
    RestaurantStore.addListeners(this.restaurantListeners);

    this.loadRestaurantsGroup();
  }

  componentWillUnmount() {
    RestaurantStore.removeListeners(this.restaurantListeners);
  }

  loadRestaurantsGroup() {
    this.showLoading();

    const restaurantsGroupId = ProAccountStore.getMeAccount().domainsList[0].restaurantsGroupId;
    RestaurantAction.retrieveRestaurantsGroup(restaurantsGroupId);
  }

  //
  // Listeners
  //
  get restaurantListeners() {
    return [
      new Listener(Events.LOAD_RESTAURANTS_GROUP_SUCCESS, this.onLoadRestaurantsGroup),
      new Listener(Events.LOAD_RESTAURANTS_GROUP_FAILURE, this.onLoadRestaurantsGroupError),
    ];
  }

  //
  // Events
  //
  onLoadRestaurantsGroup = () => {
    this.setState({
      loading: false,
      restaurantsGroup: RestaurantStore.getRestaurantsGroup()
    });
  };

  onLoadRestaurantsGroupError = () => {
    this.setState({
      loading: false,
    });
  };

  //
  // Table event
  //

  onShowRestaurantsGroupDetail = (restaurantsGroup:RestaurantsGroup) => {

  };

  //
  // Renderers
  //

  renderAddRole() {
    return (
      <RoundButton
        onClick={this.onAddRoleClicked}
        text="Ajouter un rôle"
      />
    );
  }

  renderRestaurantsGroupList() {
    return (
      <div className="top-buffer-50">
        <div className="col-xs-12 col-md-4">
          <h3>Liste de vos restaurants</h3>
        </div>
        <div className="col-xs-12 top-buffer-50">
          <RestaurantsGroupHierarchyView
            restaurantsGroup={this.state.restaurantsGroup}
            onShowRoleDetail={this.onShowRoleDetail}
          />
        </div>
      </div>
    );
  }

  renderBody() {
    if (_.isNull(this.state.restaurantsGroup)) {
      return this.renderOnLoadingContent();
    }

    return (
      <div className="top-buffer-50">
        <p>
          Voici la liste de vos restaurant accessibles suivant votre profil utilisateur.
          Chaque nouvel utilisateur doit être rattaché à (i) un restaurant ou un groupe de
          restaurants et à (ii) un rôle.
        </p>

        {this.renderRestaurantsGroupList()}
      </div>
    );
  }

  render() {
    return (
      <div className="roles_page">
        <Ariane icon={this.arianeIcon} details={this.arianeDetails} />
        {this.renderLoading()}
        {this.renderBody()}
      </div>
    );
  }
}
